<template>
  <Page>
    <SidePageColumn side="left">
      <FeaturedSidePromotions
        :page="page"
        section="left"
      ></FeaturedSidePromotions>
    </SidePageColumn>

    <CenterPageColumn :has_nav_bar="true">
      <CenterNavbar
        :crumps="crumps"
        :title="title"
        :width_class="center_width_class"
      ></CenterNavbar>

      <div
        class="componet-has-nav-bar white pt-2"
        id="promotions_group_page_top"
      >
        &nbsp;
      </div>
      <CardedSectionHeader
        icon="mdi-group"
        :label="label"
        id="promotions_group_promotions_section"
      ></CardedSectionHeader>

      <div class="white pt-5" style="min-height: 100px">
        <v-row no-gutters>
          <v-col
            cols="12"
            class="pa-2"
            v-for="(promotion, index) in promotions"
            :key="index"
            :id="'promo_group_promo_item_' + promotion.id"
          >
            <PromotionHeader
              :is_loading="is_loading"
              :promotion="promotion"
              :is_owner_view="false"
              :is_in_admin_view="false"
              :is_in_public_view="true"
              cmp_class="d-flex justify-space-between elevation-2 text-left"
            ></PromotionHeader>
          </v-col>
          <v-col cols="12" class="text-center">
            <v-btn
              rounded
              outlined
              color="success"
              :disabled="is_loading"
              class="mt-5 mb-5"
              v-if="loaded_group_count < group_count"
              @click="on_click_load_next()"
            >
              View Next
              {{ next_num }}
              {{ group_name.replace("_", " ") }} Promotions
            </v-btn>
          </v-col>
        </v-row>
      </div>

      <Footer
        :is_loading="is_loading"
        @on-hide-loader="$emit('on-hide-loader')"
        @on-show-loader="$emit('on-show-loader')"
      ></Footer>
    </CenterPageColumn>

    <SidePageColumn side="right">
      <SelfPromoAdd :page="page" section="right"></SelfPromoAdd>
      <HomeSideAdsContainer
        :page="page"
        side="right"
        :number_of_ads="3"
      ></HomeSideAdsContainer>
    </SidePageColumn>
  </Page>
</template>

<script>
import Page from "./../../components/Page";
import SidePageColumn from "./../../components/SidePageColumn";
import FeaturedSidePromotions from "./../../components/FeaturedSidePromotions";
import SelfPromoAdd from "./../../components/SelfPromoAdd";
import HomeSideAdsContainer from "./../../components/HomeSideAdsContainer";
import CenterPageColumn from "./../../components/CenterPageColumn";
import CardedSectionHeader from "./../../components/CardedSectionHeader";
import CenterNavbar from "./../../components/CenterNavbar";
import Footer from "./../../components/CenterFooter";
import QuickSideLinks from "./../../components/QuickSideLinks";
import PromotionHeader from "./../../components/PromotionHeader";

import page_info from "./../../lib/page_info";
import Utils from "./../../lib/Utils";
import ServerClient from "./../../lib/ServerClient";
export default {
  name: "PromotionsGroup",
  components: {
    Page,
    SidePageColumn,
    FeaturedSidePromotions,
    SelfPromoAdd,
    HomeSideAdsContainer,
    CenterPageColumn,
    CenterNavbar,
    Footer,
    CardedSectionHeader,
    QuickSideLinks,
    PromotionHeader,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    page: "promotion_group",
    title: "",
    crumps: [],
    group_name: "",
    group_count: 0,
    loaded_group_count: 0,
    promotions: [],
    group_page: 0,
    page_size: page_info.promotions_group_page_size,
    center_width_class: page_info.center_width_class,
    limit: page_info.promotions_most_viewed_min_value,
    label: "",
    // image_link: require("../../assets/lady_2.png"),
  }),
  methods: {
    scroll_to_secton(lmnt_id) {
        var vm =this;
      try {
        setTimeout(() => {
          var options = {
            offset: 50,
            duration: 1000,
            easing: "easeInOutCubic",
          };
          vm.$vuetify.goTo("#" + lmnt_id, options);
        }, 1000);
      } catch (error) {
        console.log(
          "Error scrolling to section on promotions group page ",
          error,
          lmnt_id
        );
      }
    },
    comma(v) {
      if (v < 10) {
        v = "0" + v.toString();
      }
      return Utils.add_commas(v);
    },
    set_promo_expired(promo, php_time_now) {
      promo.expiry = "";
      if (php_time_now < parseFloat(promo.starts_on_timestamp)) {
        promo.expiry = "pending";
      } else if (
        php_time_now >= parseFloat(promo.starts_on_timestamp) &&
        php_time_now <= parseFloat(promo.ends_on_timestamp)
      ) {
        promo.expiry = "live";
      } else if (php_time_now > parseFloat(promo.ends_on_timestamp)) {
        promo.expiry = "expired";
      }
      return promo;
    },
    load_page_page_dependencies() {
      var php_time_now = Utils.date_str_to_php_time();
      this.label = "";
      if (this.group_name != "most_viewed") {
        this.limit = 0;
      }
      this.$emit("on-show-loader");
      ServerClient.Promotions.get_promotion_group_page_dependencies(
        {
          time_now: php_time_now,
          group: this.group_name,
          limit: this.limit,
        },
        (res) => {
          this.$emit("on-hide-loader");
          this.group_count = parseInt(res);
          this.label =
            "This Group Contains " +
            this.comma(this.group_count) +
            " Promotions";
          this.load_promotions_group();
        },
        (errors) => {
          this.$emit("on-hide-loader");
          console.log(
            "Errors while loading public promotions page group dependencies",
            errors
          );
        }
      );
    },
    load_promotions_group() {
      this.group_page = this.group_page + 1;
      var php_time_now = Utils.date_str_to_php_time();
      this.$emit("on-show-loader");
      ServerClient.Promotions.get_promotion_group_page(
        {
          time_now: php_time_now,
          group: this.group_name,
          limit: this.limit,
          page: this.group_page,
          page_size: this.page_size,
        },
        (res) => {
          var top_item_id = 0;
          if (res.promotions.length > 0) {
            top_item_id = res.promotions[0].id;
          }

          //preprocess featured promotions
          var promos = [];
          var promo_ids = [];
          for (var index = 0; index < res.promotions.length; index++) {
            var promo = res.promotions[index];
            var promo_id = parseInt(promo.id);
            if (promo_ids.indexOf(promo_id) < 0) {
              //expiry
              promo = this.set_promo_expired(promo, php_time_now);
              promos.push(promo);
              promo_ids.push(promo_id);
            }
          }

          this.promotions = this.promotions.concat(promos);
          this.loaded_group_count = this.promotions.length;

          this.$emit("on-hide-loader");

          //scroll to the top
          if (top_item_id > 0) {
            this.scroll_to_secton("promo_group_promo_item_" + top_item_id);
          }
        },
        (errors) => {
          this.$emit("on-hide-loader");
          console.log("Errors while loading public errors page", errors);
        }
      );
    },
    on_click_load_next(){
      var rem = this.group_count - this.loaded_group_count;
      if(rem > 0){
        this.load_promotions_group();
      }
    }
  },
  computed:{
    next_num(){
      var num = 0;
      var rem = this.group_count - this.loaded_group_count;
      if(rem > this.page_size){
        rem = this.page_size;
      }
      num = this.comma(rem);
      return num;
    }
  },
  mounted() {
    this.group_name = this.$route.params.group_name;
    this.crumps = [
      {
        text: "Promotions",
        disabled: false,
        href: "/promotions",
      },
      {
        text: this.group_name,
        disabled: true,
        href: "/promotions/group/" + this.group_name,
      },
    ];
    this.title = "View " + this.group_name.replace("_", " ") + " Promotions";
    if (this.group_name != "most_viewed") {
      this.limit = 0;
    }
    this.load_page_page_dependencies();
  },
};
</script>